import React, { useState } from 'react';
import { Sparkles, X } from 'lucide-react';
import { companyInfo } from '../../mock';
import { HolidayBookingDialog } from '../holiday/HolidayBookingDialog';

const MESSAGES = [
  'Now booking Christmas light installations',
  'Free design estimate for your home or storefront',
  'Commercial-grade warm-white LEDs, zero roof damage',
  'In-season maintenance & January takedown included',
  `Call or text ${companyInfo.phone} to reserve your install date`,
  'Tap here to pick your install date',
];

const TickerRow = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {MESSAGES.map((msg) => (
      <span key={msg} className="flex items-center px-6 text-sm font-semibold tracking-wide whitespace-nowrap">
        <Sparkles className="w-4 h-4 mr-2 text-yellow-400" />
        {msg}
      </span>
    ))}
  </div>
);

export const ChristmasTicker = ({ onClose }) => {
  const [bookingOpen, setBookingOpen] = useState(false);

  return (
    <div className="relative bg-[#0b1220] text-white border-b border-yellow-400/40" data-testid="christmas-ticker">
      <button
        type="button"
        onClick={() => setBookingOpen(true)}
        className="ticker-wrap block w-full overflow-hidden h-9 pr-10"
        data-testid="christmas-ticker-link"
        aria-label="Book a Christmas light installation date"
      >
        <div className="ticker-track flex w-max h-9 items-center">
          <TickerRow />
          <TickerRow hidden />
        </div>
      </button>
      <button
        onClick={onClose}
        className="absolute right-0 top-0 h-9 w-10 flex items-center justify-center bg-[#0b1220] text-gray-300 hover:text-yellow-400 transition-colors"
        data-testid="christmas-ticker-close"
        aria-label="Close Christmas banner"
      >
        <X className="w-4 h-4" />
      </button>
      <HolidayBookingDialog open={bookingOpen} onOpenChange={setBookingOpen} />
    </div>
  );
};
